import React from "react";
import { FaCircleCheck } from "react-icons/fa6";
import { MdError } from "react-icons/md";
import { GrPowerReset } from "react-icons/gr";
import "./style.css";

const SingleImageSpinner = ({ retryHandler, file }) => {
  console.log("render image upload spinner");
  console.log("file :", file);
  if (file.isOverSize) {
    return (
      <div className="each-image-spinner-container">
        <div className="msg--container error--msg--container">
          <MdError className="msg--error--icon" />
          <p className="msg--error--text text-center text-danger">{"Atmost 5MB large file are only allowed"}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="each-image-spinner-container">
      {file.status === "pending" ? (
        <div className="msg--container pending--msg--container">
          <div className="each-image-spinner"></div>
        </div>
      ) : file.status === "success" ? (
        <div className="msg--container success--msg--container">
          <FaCircleCheck className="msg--success--icon" />
          <p className="msg--success--text">{"Successfully"}</p>
        </div>
      ) : file.status === "failure" ? (
        <div className="msg--container error--msg--container">
          <MdError className="msg--error--icon" />
          <p className="msg--error--text">{"Unsuccessfull"}</p>
          <button className="retry--btn" onClick={() => retryHandler(file)}>
            <GrPowerReset className="msg--error--icon" />
          </button>
        </div>
      ) : (
        <div className="msg--container error--msg--container">
          {" "}
          <b className="text-center msg--error--text">Something went wrong</b>
        </div>
      )}
    </div>
  );
};

export default SingleImageSpinner;
